<template>
    <v-card class="ma-2 main-info">
        <v-card-text class="main-info-text">
            <input type="file" v-if="uploadReady" @change="onChangePhoto" ref="file" style="display:none" accept=".png, .jpg, .jpeg"/>
            <v-layout>
                <div @click="photoClick" class="avatar-layout" v-bind:class="{ 'avatar-disabled': !isEditEnabled }">
                    <v-avatar size="40px">
                        <img :src="srcPhoto" alt="avatar" class="avatar-image">
                    </v-avatar>
                    <v-flex class="title-photo">
                        <p>{{ `${firstName} ${lastName}` }}</p>
                        <p v-if="isEditEnabled" @click="dialogEditPhoto=true" style="color: #3c4cae">{{ titlePhoto }}</p>
                    </v-flex>
                </div>
                <v-flex v-if="isEditEnabled" align-center ml-3>
                    <v-checkbox class="google-checkbox" :label="'Don`t create Google account'" v-model="createGoogleAccount" color="indigo"></v-checkbox>
                </v-flex>
            </v-layout>
            <div class="main-info-name">
                <v-text-field autocomplete="off" v-model="email" label="Email " :rules="!isDevEnv ? emailRules : []" class="mr-2 p-2 input-email input-card"
                    @blur.stop="isGoogleAccountExist" :required="!createGoogleAccount" :disabled="isEmployeeEdit() || !isEditEnabled"></v-text-field>
                <v-text-field autocomplete="off" v-if="newEmployee && !createGoogleAccount" v-model="password" label="Password" class="input-card password-field" 
                    :rules="!createGoogleAccount && requiredRules" :required="!createGoogleAccount" :append-icon-cb="changePasswordIcon"
                    :append-icon="showPassword ? 'visibility_off' : 'visibility'" :type="showPassword ? 'text' : 'password'"
                >
                </v-text-field>
                <v-text-field autocomplete="off" v-if="!newEmployee && !createGoogleAccount" v-model="password" label="Password" class="input-card password-field"
                    :append-icon="showPassword ? 'visibility_off' : 'visibility'" :type="showPassword ? 'text' : 'password'"
                    :append-icon-cb="changePasswordIcon" :disabled="!isEditEnabled"
                >
                </v-text-field>
            </div>
            <div class="main-info-name main-info-firstname">
                <v-text-field v-model="firstName" label="First name " :rules="requiredRules" class="mr-2 input-firstname input-card"
                    required :disabled="!isEditEnabled"
                ></v-text-field>
                <v-text-field v-model="lastName" label="Last name " :rules="requiredRules" class="input-card"
                    required :disabled="!isEditEnabled"
                ></v-text-field>
            </div>
            <div class="main-info-coordinator main-info-name main-info-firstname mb-1">
                <v-select content-class="users-coordinator" label="Coordinator" class="select-card coordinator-select mr-2" v-bind:items="coordinatorsList.filter(isNotSelfUser)" 
                    v-model="coordinator" bottom :required="isCoordinatorRequired" :disabled="isDirector() || !isEditEnabled"
                    :rules="isCoordinatorRequired ? [v => (v !== '' && !!v) || 'Choose coordinator' ] : []"
                ></v-select>
            </div>
            <v-flex>
                <v-text-field v-model="vacationDays" label="Vacation days" mask="###" :rules="requiredRules" class="input-card" required :disabled="!isEditEnabled"></v-text-field>
            </v-flex>
            <v-flex class="main-info-track">
                <v-checkbox class="employee-checkbox" :label="'Track time in JIRA'" v-model="trackJira" color="indigo" :disabled="!isEditEnabled"></v-checkbox>
            </v-flex>
        </v-card-text>
        <add-photo ref="modal" v-if='dialogEditPhoto' @addPhoto="choosePhoto" @savePhoto="savePhoto" @delete="deletePhoto" @cancel="dialogEditPhoto=false"></add-photo>
    </v-card>
</template>
<script>
    import { mapActions, mapGetters } from 'vuex';
    import AddPhoto from '@/components/reusable/add-photo';

    export default {
        name: 'employee-main-info',
        components: {
            'add-photo': AddPhoto
        },
        data() {
            return {
                requiredRules: [
                    (v) => !!v || ''
                ],
                emailRules: [
                    (v) => !!v || '',
                    (v) => /^\w+([\\.-]?\w+)*@\w+([\\.-]?\w+)*(\.[A-Za-z0-9]{2,3})+$/.test(v) || 'Invalid email',
                    (v) => this.checkEmail(v) || `Email should belong to #DOMAINS# domains`
                ],
                uploadingPhoto: null,
                dialogEditPhoto: false,
                contentDlg: {},
                uploadReady: true,
                showPassword: false
            };
        },
        props: ['newEmployee'],
        computed: {
            ...mapGetters({
                roles: 'getRoles',
                directorAndCoordinators: 'getDirectorAndCoordinators',
                getDirectorOrCoordinatorById: 'getDirectorOrCoordinatorById',
                getDirectorById: 'getDirectorById',
                googleAccountInfo: 'getGoogleAccountInfo',
                originalEmployee: 'getOriginalEmployee',
                employee: 'getEmployee',
                employeePassword: 'getEmployeePassword'
            }),
            selectedRole() {
                return this.roles.find(r => r.checked && r.name.toLowerCase() !== 'administrator');
            },
            coordinatorsList() {
                let coordinators = this.directorAndCoordinators.map(item => ({
                    text: `${item.firstname} ${item.lastname}`,
                    value: item.userId
                }));
    
                if (!coordinators.length) {
                    coordinators = [{
                        text: '[Empty]',
                        value: ''
                    }];
                }

                return coordinators;
            },
            email: {
                get() {
                    return this.$store.state.employees.employee.email;
                },
                set(value) {
                    this.editEmployeeEmail(value);
                }
            },
            password: {
                get() {
                    return this.employeePassword ? this.employeePassword : '';
                },
                set(value) {
                    this.editEmployeePassword(value);
                }
            },
            firstName: {
                get() {
                    return this.$store.state.employees.employee.firstname;
                },
                set(value) {
                    this.editEmployeeFirstname(value);
                }
            },
            lastName: {
                get() {
                    return this.$store.state.employees.employee.lastname;
                },
                set(value) {
                    this.editEmployeeLastname(value);
                }
            },
            coordinator: {
                get() {
                    return (!this.isDirector() && this.$store.state.employees.employee.coordinator) ? this.$store.state.employees.employee.coordinator.userId : '';
                },
                set(value) {
                    this.editEmployeeCoordinator(this.getDirectorOrCoordinatorById(value));
                }
            },
            photoUrl: {
                get() {
                    return this.$store.state.employees.employee.photoUrl;
                },
                set(value) {
                    this.editEmployeePhotoUrl(value);
                }
            },
            trackJira: {
                get() {
                    return this.$store.state.employees.employee.trackJira;
                },
                set(value) {
                    this.editEmployeeTrackJira(value);
                }
            },
            vacationDays: {
                get() {
                    return this.$store.state.employees.employee.vacationDays;
                },
                set(value) {
                    value = parseInt(value) || 0;
                    this.editEmployeeVacationDays(value);
                }
            },
            createGoogleAccount: {
                get() {
                    return !this.$store.state.employees.employee.createGoogleAccount;
                },
                set(value) {
                    this.editGoogleAccountCreation(!value);
                }
            },
            srcPhoto() {
                return this.uploadingPhoto ? this.uploadingPhoto
                    : (this.photoUrl ? `${process.env.API}/img/${this.photoUrl}` : require('@/assets/no-photo.png'));
            },
            titlePhoto() {
                return this.photoUrl ? 'Edit your profile picture' : 'Add your profile picture';
            },
            isCoordinatorRequired() {
                const checkedRoles = this.roles.filter(r => r.checked);
                return checkedRoles.length === 0 ||
                    (!checkedRoles.some(r => r.name.trim().toLowerCase() === 'director') && checkedRoles.some(r => r.name.trim().toLowerCase() !== 'administrator'));
            },
            isEditEnabled() {
                return !this.employee.archived;
            },
            isDevEnv() {
                return process.env.NODE_ENV === 'development' || process.env.DEMO_ENV === true;
            }
        },
        methods: {
            ...mapActions(['editEmployeeEmail',
                'editEmployeePassword',
                'editEmployeeFirstname',
                'editEmployeeLastname',
                'editEmployeeCoordinator',
                'editEmployeePhotoUrl',
                'editEmployeeTrackJira',
                'editEmployeeVacationDays',
                'setUploadingPhoto',
                'clearEmployeeCoordinator',
                'editGoogleAccountCreation']),
            handleFiles(files) {
                if (!files || !files[0]) {
                    return;
                }
                let reader = new FileReader();
                reader.onload = this.onPhotoLoaded;
                this.setUploadingPhoto(files[0]);
                reader.readAsDataURL(files[0]);
            },
            onPhotoLoaded(e) {
                this.$refs.modal._data.photoPreview = e.target.result;
            },
            onChangePhoto(event) {
                this.handleFiles(event.target.files);
            },
            deletePhoto() {
                this.uploadingPhoto = null;
                this.editEmployeePhotoUrl('');
                this.setUploadingPhoto(null);
                this.dialogEditPhoto = false;
                this.clearFile();
            },
            choosePhoto() {
                this.$refs.file.click();
            },
            savePhoto() {
                this.dialogEditPhoto = false;
                this.uploadingPhoto = this.$refs.modal._data.photoPreview;
            },
            clearFile() {
                this.uploadReady = false;
                this.$nextTick(() => {
                    this.uploadReady = true;
                });
            },
            showDialog() {
                this.dialogEditPhoto = true;
            },
            isNotSelfUser(coordinator) {
                return this.$route.params.userId !== coordinator.value;
            },
            isDirector() {
                const director = this.roles.find(item => item.name.toLowerCase() === 'director');
                const checked = director ? director.checked : false;
                if (checked) {
                    this.clearEmployeeCoordinator();
                }
                return checked;
            },
            changePasswordIcon() {
                this.showPassword = !this.showPassword;
            },
            isGoogleAccountExist() {
                if (!!this.email && this.email !== this.originalEmployee.email) {
                    this.$store.dispatch('isGoogleAccountExist', this.email)
                        .then(res => {
                            if (res.isError) {
                                this.$emit('showGoogleError');
                            }
                        });
                }
            },
            isEmployeeEdit() {
                return this.$route.name === 'EmployeeEdit' || this.$route.name === 'EmployeeArchiveEdit';
            },
            photoClick() {
                if (this.isEditEnabled) {
                    this.dialogEditPhoto = true;
                }
            },
            checkEmail(email) {
                const domains = process.env.DOMAINS.split(',');
                let isValidDomain = false;

                domains.forEach(domain => {
                    if(email.endsWith(domain)){
                        isValidDomain = true;
                    }
                });

                return isValidDomain;
            }
        }
    };
</script>

<style scoped>
    .card__text.main-info-text {
        padding-top: 21px;
        padding-left: 20px;
        padding-bottom: 18px;
    }
    .main-info-text .input-group__input {
        min-height: 10px;
        height: 10px;
    }
    .main-info-name {
        display: flex;
        flex-direction: row;
        max-height: 53px;
    }
    .main-info-firstname {
        margin-bottom: -5px;
    }
    .main-info-track {
        max-height: 33px;
        padding-top: 5px;
    }
    .flex.main-info-coordinator {
        height: 57px;
    }
    .main-info-coordinator >>> label{
        transform: translateY(-18px) scale(1) !important;
    }
    .coordinator-select >>> .input-group__selections__comma {
        margin-top: 6px;
    }
    @media screen and (max-width: 600px) {
        .main-info-name {
            flex-direction: column;
            max-height: 106px;
        }
    }
    .avatar-layout
    {
        cursor: pointer;
        margin-bottom: 8px;
        display: flex;
        display: -webkit-flex;
    }
    .avatar-disabled
    {
        cursor: default;
    }
    .avatar-layout p {
        margin-bottom: 0px;
    }

    .title-photo p {
        overflow: hidden;
        text-overflow: ellipsis;
    }

    .title-photo {
        overflow: hidden;
        align-self: center;
        margin-left: 20px;
    }

    .avatar-image {
        object-fit: cover;
    }

    .google-checkbox {
        margin-top: 6px;
    }

    .google-checkbox >>> .input-group__details {
        display: none;
    }
</style>


// WEBPACK FOOTER //
// src/components/reusable/EmployeeMainInfo.vue